const FormTitle = (props) => {
    return <h3 style={{ display: props.display }}>{props.title}</h3>;
};

export default FormTitle;
